/**
 * Connector Correlation Service
 * Service for connector interface
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CoalitionProgramBookingFieldsDto } from './coalition-program-booking-fields-dto';


export interface CoalitionProgramBookingRequestDto { 
    /**
     * Timestamp when the booking is made (ISO 8601 recommended)
     */
    bookingTime?: string;
    /**
     * Type of booking: points earned (EARNBOOKING) or points burned (BURNBOOKING)
     */
    bookingType: CoalitionProgramBookingRequestDto.BookingTypeEnum;
    /**
     * Program-specific booking type or category code
     */
    bookingTypeCode: string;
    /**
     * Number of points to book (earn or burn)
     */
    points: number;
    /**
     * Human-readable reason or description for the booking
     */
    reason: string;
    /**
     * External reference ID for idempotency or reconciliation
     */
    referenceId?: string;
    /**
     * Value date/time for the booking (ISO 8601 recommended)
     */
    valueTime?: string;
    /**
     * Partner id; required together with storeId to look up the store via program-core
     */
    partnerId?: string;
    /**
     * Store id; required together with partnerId to look up the store via program-core
     */
    storeId?: string;
    /**
     * Program-specific booking data (e.g. Payback: VAT rate, marketing code)
     */
    coalitionPrograms?: CoalitionProgramBookingFieldsDto;
}
export namespace CoalitionProgramBookingRequestDto {
    export type BookingTypeEnum = 'BURNBOOKING' | 'EARNBOOKING';
    export const BookingTypeEnum = {
        Burnbooking: 'BURNBOOKING' as BookingTypeEnum,
        Earnbooking: 'EARNBOOKING' as BookingTypeEnum
    };
}


